export enum ChangeLocationType {
  MoveToLocality = 0,
  MoveToPosition = 1,
}
